var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"px-2 mr-2",style:(("width: " + _vm.width + "; height: " + _vm.height + ";")),attrs:{"id":"ax-input","type":"text","spellcheck":"false"}})}
var staticRenderFns = []

export { render, staticRenderFns }